export const requestTypes = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};

export const controllers = {
  label: 'Label/',
  refund: 'Refund/',
  report: 'Report/',
  auth: 'Auth/',
  shipments: 'Shipments/',
  agent: 'Agent/',
  foxContainer: 'FoxContainer/',
  user: 'User/',
  parcelRates: 'ParcelRates/',
  canpar: 'Canpar/',
  documents: 'Documents/',
};

export const responseTypes = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  notification: 'Notification',
};
